import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { buildProposalLineExplainQuestion } from "@shared/proposalCleoInProposalExplain";
import { CircleHelp } from "lucide-react";

type Props = {
  label: string;
  onAsk: (question: string) => void;
  className?: string;
};

/**
 * Visible `?` control — click opens Ask Cleo with a prefilled explain question.
 * Primary path is tap/click, not hover.
 */
export default function ProposalLineAskCleoButton({ label, onAsk, className }: Props) {
  const question = buildProposalLineExplainQuestion(label);
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        "h-7 w-7 shrink-0 rounded-full border border-[#1A2744]/20 bg-white text-[#1A2744] hover:bg-[#1A2744]/8 hover:text-[#1A2744]",
        className,
      )}
      aria-label={`Ask Cleo: ${question}`}
      title={question}
      data-testid="proposal-line-ask-cleo"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onAsk(question);
      }}
    >
      <span className="sr-only">?</span>
      <CircleHelp className="h-4 w-4" aria-hidden />
    </Button>
  );
}
